import { z } from "zod";
import {
  defaultDefinePasswordValues,
  definePasswordSchema,
} from "./define-password.schema";

export const createPasswordSchema = definePasswordSchema.extend({
  firstName: z.string().max(64, "Veuillez entrer un prénom valide"),
  lastName: z.string().max(64, "Veuillez entrer un nom valide"),
});

export const defaultCreatePasswordValues = {
  ...defaultDefinePasswordValues,
  firstName: "",
  lastName: "",
};

export type CreatePasswordForm = z.infer<typeof createPasswordSchema>;
